import Mutations from '../../odata/mutations';

export default { ...new Mutations('expenseDocuments'), ...new Mutations('expenseDocument') };
